import type { ReactElement } from "react";

import { useFlags } from "launchdarkly-react-client-sdk";

import { SpaceAccessGuard } from "src/components/spaces/space-access-guard";

type Props = {
  children: ReactElement;
};

export const AgentChatsInSpacesRoute = ({ children }: Props) => {
  const { appAgentChatsInSpaces } = useFlags();

  return (
    <SpaceAccessGuard
      spacesAccess={
        appAgentChatsInSpaces === true
          ? "accessible-from-limited-view"
          : "hidden-from-limited-view"
      }
    >
      {children}
    </SpaceAccessGuard>
  );
};
